var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 418,
    viewBox: "0 0 488 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.62402,
    width: 485.981,
    height: 416.004,
    rx: 25,
    transform: "rotate(0.22369 1.62402 0)",
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1836,
    y: 45.175,
    width: 428.23,
    height: 322.403,
    transform: "rotate(0.22369 29.1836 45.175)",
    fill: "#F9FEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 112H427V324C427 337.807 415.807 349 402 349H119C105.193 349 94 337.807 94 324V112Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 112H427V97C427 83.1929 415.807 72 402 72H119C105.193 72 94 83.1929 94 97V112Z",
    fill: "#CC748F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 149C118 143.477 122.477 139 128 139H260C265.523 139 270 143.477 270 149V150C270 155.523 265.523 160 260 160H128C122.477 160 118 155.523 118 150V149Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 206C112 200.477 116.477 196 122 196H385C390.523 196 395 200.477 395 206V207C395 212.523 390.523 217 385 217H122C116.477 217 112 212.523 112 207V206Z",
    fill: "#707070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 246C112 240.477 116.477 236 122 236H385C390.523 236 395 240.477 395 246V247C395 252.523 390.523 257 385 257H122C116.477 257 112 252.523 112 247V246Z",
    fill: "#707070"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112 286C112 280.477 116.477 276 122 276H379C384.523 276 389 280.477 389 286V287C389 292.523 384.523 297 379 297H122C116.477 297 112 292.523 112 287V286Z",
    fill: "#707070"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 45,
    width: 38,
    height: 323,
    fill: "#2FC06B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature_2.5ab09d08.svg";
export { ForwardRef as ReactComponent };